import { OTP_LENGTH, normalizeCode } from './otp'

/**
 * WebOTP (otp-autofill): Chrome on Android — the installed PWA included —
 * hands the page the code from the login SMS, after one tap on the
 * system sheet, when the SMS ends with `@parrots.club #<code>` (the
 * backend appends it, sms.service.ts `webOtpLine`) and the page's origin
 * is that host. Everywhere else this is a silent no-op: iOS Safari offers
 * the code above the keyboard from `autocomplete="one-time-code"` on the
 * field itself, and a desktop browser just has the learner type it.
 */
export function webOtpSupported(win = typeof window === 'undefined' ? undefined : window) {
  return Boolean(win && 'OTPCredential' in win && win.navigator?.credentials?.get)
}

/**
 * Waits for the code. Resolves to the normalized code, or null when the
 * browser cannot do this, the learner dismissed the sheet, the wait was
 * aborted (step left, page closed, timeout) or the SMS carried something
 * that is not a code. Never rejects: autofill failing must look exactly
 * like autofill not existing.
 */
export async function receiveOtp(signal, win = typeof window === 'undefined' ? undefined : window) {
  if (!webOtpSupported(win)) return null
  try {
    const credential = await win.navigator.credentials.get({ otp: { transport: ['sms'] }, signal })
    const code = normalizeCode(credential?.code ?? '')
    return code.length === OTP_LENGTH ? code : null
  } catch {
    return null
  }
}
